import { RESET_EMAIL_CHECK } from './constants';

export const resetEmailCheck = () => ({ type: RESET_EMAIL_CHECK });
